import { Box, Stack } from "@mui/material";
import { SubscriptionObject } from "../../../bt-common/services/subscription-object.class";
import { useTranslation } from "react-i18next";
import { namespace } from "@common-config/constants";

export interface PlanDescriptionProps {
    subscription?: SubscriptionObject;
}

export default function PlanDescription({ subscription }: PlanDescriptionProps) {
    const { t, i18n } = useTranslation(namespace);
    const activeLocale = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0].toLowerCase();

    return (
        <Stack>
            <Stack direction="row">
                <Box flexBasis={120} flexGrow={0} flexShrink={0}>{t('upgradeBox.currentPlan')}:</Box>
                <Box flex="auto">{subscription?.planName}</Box>
            </Stack>
            <Stack direction="row">
                <Box flexBasis={120} flexGrow={0} flexShrink={0}>{t('upgradeBox.renewalDate')}:</Box>
                <Box flex="auto">{subscription?.renewalTime?.clone().locale(activeLocale).format('MMM D, YYYY')}</Box>
            </Stack>
        </Stack>
    );
}
